import React from "react";
import { Button } from "semantic-ui-react";
import { cleanRegister } from "../../../../app/store/actions/registerActions";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";

const actions = {
  cleanRegister,
};

const RegisterRecover = ({ cleanRegister }) => {
  return (
    <Button
      as={Link}
      to="/recover"
      fluid
      basic
      color="blue"
      size="mini"
      content="¿Olvidaste tu contraseña?"
      onClick={() => cleanRegister()}
    />
  );
};
RegisterRecover.propTypes = {
  cleanRegister: PropTypes.func.isRequired,
};
export default connect(null, actions)(RegisterRecover);
